import http from "@/shared/axios-config/g-http-metodos";

function GetInformacaoTipoCartaEnum(){
    const { res, erro, requisicao } = http.getArray("CartaProposta/GetTipoCartaEnum");
    return { StatusArray: res, erro, requisicao }
}

function GetOrcamentoByCartaPropostaId(CartaPropostaId){
    const { res, erro, requisicao } = http.getArray(`CartaProposta/GetOrcamentoByCartaPropostaId/${CartaPropostaId}`);
    return { StatusArray: res, erro, requisicao }
}

function GetMarkupInformacoesByOrcamentoId(orcamentoId, cartaPropostaId){
    const { res, erro, requisicao } = http.getArray(`CartaProposta/GetMarkupInformacoesByOrcamentoId/${orcamentoId}/${cartaPropostaId}`);
    return { Infos: res, erro, requisicao }
}

function GetInformacaoStatusCartaEnum(){
    const { res, erro, requisicao } = http.getArray("CartaProposta/GetStatusCartaEnum");
    return { StatusArray: res, erro, requisicao }
}

function GetCartaPropostaByFiltro(objFiltros){
    const { res, erro, requisicao } = http.postArray("/CartaProposta/GetCartaPropostaByFiltro",objFiltros);
    return { StatusArray: res, erro, requisicao }
}

function GetCartaPropostaDigitacaoByFiltro(objFiltros){
    const { res, erro, requisicao } = http.postArray("/CartaProposta/GetCartaPropostaDigitacaoByFiltro",objFiltros);
    return { StatusArray: res, erro, requisicao }
}

function ExcluirCartaPropostaDigitacao(CartaPropostaId){
    const { res, erro, requisicao } = http.postArray(`/CartaProposta/ExcluirCartaPropostaDigitacao/${CartaPropostaId}`);
    return { StatusArray: res, erro, requisicao }
}

function setMotivoBaixarOrcamento(popup){
    const { res, erro, requisicao } = http.postArray(`/CartaProposta/setMotivoBaixarOrcamento`, popup);
    return { StatusArray: res, erro, requisicao }
}

function GetStatusSituacaoCartaPropostaEnum(){
    const { res, erro, requisicao } = http.getArray("CartaProposta/GetStatusSituacaoCartaPropostaEnum");
    return { StatusArray: res, erro, requisicao }
}

function GetParametrosComissao(){
    const { res, erro, requisicao } = http.getArray("CartaProposta/GetParametrosComissao");
    return { ParametrosComissao: res, erro, requisicao }
}

function GetEnumMotivoBaixa(){
    const { res, erro, requisicao } = http.getArray("CartaProposta/GetEnumMotivoBaixa");
    return { MotivoBaixaArray: res, erro, requisicao }
}

function GetConcorrentes(){
    const { res, erro, requisicao } = http.getArray("CartaProposta/GetConcorrentes");
    return { ConcorrenteArray: res, erro, requisicao }
}

function createNewCartaPropostaVersion(CartaPropostaId){
    const { res, erro, requisicao } = http.postArray(`CartaProposta/createNewCartaPropostaVersion/${CartaPropostaId}`);
    return { VersionCartaPropostaArray: res, erro, requisicao }
}

function GetCartaPropostaResumoLateralStep1(CartaPropostaId){
    const { res, erro, requisicao } = http.getArray(`CartaProposta/GetCartaPropostaResumoLateralStep1/${CartaPropostaId}`);
    return { CartaPropostaArray: res, erro, requisicao }
}

function GetCartaPropostaResumoLateralStep2(CartaPropostaId){
    const { res, erro, requisicao } = http.getArray(`CartaProposta/GetCartaPropostaResumoLateralStep2/${CartaPropostaId}`);
    return { CartaPropostaArray: res, erro, requisicao }
}

function GetCartaPropostaResumoLateralStep3(CartaPropostaId){
    const { res, erro, requisicao } = http.getArray(`CartaProposta/GetCartaPropostaResumoLateralStep3/${CartaPropostaId}`);
    return { CartaPropostaArray: res, erro, requisicao }
}


function GetNomeEmpresaByCartaId(CartaPropostaId){
    const { res, erro, requisicao} = http.get(`CartaProposta/GetNomeEmpresaByCartaId/${CartaPropostaId}`)
    return {NomeEmpresa: res, erro, requisicao}
  }

const CartaPropostaController = {
    GetOrcamentoByCartaPropostaId,
    GetCartaPropostaResumoLateralStep3,
    GetCartaPropostaResumoLateralStep2,
    GetCartaPropostaResumoLateralStep1,
    createNewCartaPropostaVersion,
    setMotivoBaixarOrcamento,
    GetEnumMotivoBaixa,
    GetConcorrentes,
    ExcluirCartaPropostaDigitacao,
    GetInformacaoTipoCartaEnum,
    GetCartaPropostaByFiltro,
    GetCartaPropostaDigitacaoByFiltro,
    GetInformacaoStatusCartaEnum,
    GetStatusSituacaoCartaPropostaEnum,
    GetParametrosComissao,
    GetMarkupInformacoesByOrcamentoId,
    GetNomeEmpresaByCartaId
}

export default CartaPropostaController

